import {ITheme} from 'contexts/ThemeContext';
import {StyleSheet} from 'react-native';

export default (props: ITheme) => {
  return StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: props.colors.dirtyWhite,
    },
  });
};
